import { List as RadixList, TabsListProps } from '@radix-ui/react-tabs';
import { twMerge } from 'tailwind-merge';

interface ListProps extends TabsListProps {}

function List({ className, children, ...props }: ListProps) {
  return (
    <RadixList role="tablist" className={twMerge('flex flex-row gap-3', className)} {...props}>
      {children}
    </RadixList>
  );
}

export { List };
